class StorageInterface {
  async getProgress() {
    throw new Error('getProgress method in not implemented');
  }

  async saveProgress() {
    throw new Error('saveProgress method in not implemented');
  }

  async removeProgress() {
    throw new Error('removeProgress method in not implemented');
  }
}

export default StorageInterface;
